<div class="container mx-auto py-2 md:py-10 ">
  <div
    class="flex  flex-col md:flex-row items-start gap-10 bg-white/5 border border-white/10 rounded-2xl p-6 md:p-20">

    <!-- Left Image -->
    <div class="w-full md:w-1/2 flex justify-center">
      <img src="../../../../../assets/images/storev2/store-review-mobile-mock.png" alt="Enhance Vehicle Power with Varroc Connect"
        class="rounded-2xl w-full max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl object-cover">
    </div>

    <!-- Right Content -->
    <div class="w-full md:w-1/2 text-center md:text-left space-y-5">
      <!-- Heading -->
      <h3 class="text-2xl md:text-3xl font-bold text-white">
        Enhance the power of your vehicle
        with <span class="text-varroc-accent">Varroc Connect</span>
      </h3>

      <!-- Stats -->
      <div class="flex flex-col sm:flex-row justify-center md:justify-start gap-4 sm:gap-6">
        <!-- Rating -->
        <div
          class="store-container-border rounded-xl px-6 py-4 text-center shadow-md flex items-center md:items-start flex-col w-full sm:w-48 md:w-44 lg:w-48">
          <p class="text-3xl sm:text-4xl font-bold text-store-blue">4.5</p>
          <img src="../../../../../assets/images/storev2/review-rating.png" alt="" srcset="">
          <p class="text-xs sm:text-sm mt-1 text-store-blue whitespace-nowrap">Average User Rating</p>
        </div>

        <!-- Downloads -->
        <div
          class="store-container-border rounded-xl px-6 py-4 text-center shadow-md flex items-center flex-col w-full sm:w-48 md:w-44 lg:w-48">
          <p class="text-3xl sm:text-4xl font-bold text-store-blue">10K +</p>
          <p class="text-xs sm:text-sm mt-1 text-store-blue">Downloads</p>
        </div>
      </div>

      <!-- Store Buttons -->
      <div class="flex flex-col sm:flex-row justify-center md:justify-start gap-3 sm:gap-4 md:ms-[30px]">
        <a href="https://play.google.com/store/apps/details?id=com.cariq.mobility.cariqdriven" target="_blank"
          rel="noopener noreferrer" class="home_section_play_store_download_btn product_rating_and_reviews_google_play_button">
          <img src="../../../assets/images/storev2/get-on-play-store-overlay.png" alt="Download Varroc Connect App from Google Play Store"
            class="h-12 sm:h-14 w-full object-contain hover:scale-105 transition-transform duration-200 home_section_play_store_download_btn_img">
        </a>
        <a href="https://apps.apple.com/in/app/cariq-driven/id1194939452" target="_blank" rel="noopener noreferrer" class="home_section_app_store_download_btn product_rating_and_reviews_app_store_button "
          >
          <img src="../../../assets/images/storev2/get-on-app-store-overlay.png" alt="Download Varroc Connect App from Apple App Store"
            class="h-12 sm:h-14 w-full object-contain hover:scale-105 transition-transform duration-200 home_section_app_store_download_btn_img">
        </a>
      </div>
    </div>
  </div>
</div>